// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import loadable from "../../utils/loadable"
import { LicensedPharmacist, PreschoolEducation, EngineerSafety, BusinessAdministration, Pharmacy, JuniorAccountant, Advantage, Cooperationalliance } from './';

const TeacherCertification = loadable(() => import('../topic/TeacherCertification'));
const FireEngineer = loadable(() => import('../topic/FireEngineer'));

export default {
  path: 'topic',
  name: 'Topic',
  childRoutes: [
    { path: 'TeacherCertification', name: 'Default page', component: TeacherCertification, isIndex: true },
    { path: '/topic/FireEngineer', name: 'Fire engineer', component: FireEngineer },
    { path: '/topic/LicensedPharmacist', name: 'Licensed pharmacist', component: LicensedPharmacist },
    { path: '/topic/PreschoolEducation', name: 'Preschool education', component: PreschoolEducation },
    { path: '/topic/EngineerSafety', name: 'Engineer safety', component: EngineerSafety },
    { path: '/topic/BusinessAdministration', name: 'Business administration', component: BusinessAdministration },
    { path: '/topic/Pharmacy', name: 'Pharmacy', component: Pharmacy },
    { path: '/topic/JuniorAccountant', name: 'Junior accountant', component: JuniorAccountant },
    { path: '/topic/advanage', name: 'Advantage', component: Advantage },
    { path: '/topic/Cooperationalliance', name: 'Cooperationalliance', component: Cooperationalliance },
  ],
};



// WEBPACK FOOTER //
// ./src/features/topic/route.js